/* eslint-disable import/no-named-as-default-member */
import create from 'zustand';

interface ITradingModalStoreState {
  visible?: boolean;
  symbol?: string;
  price?: number;
  orderType?: string;
  showOrderbook?: boolean;
  showTabs?: boolean;
  showOrderType?: boolean;
  orderedLot?: number;
  orderid?: string;
  orderedPrice?: number;
  isAutoBuy?: boolean;
  modalData?: any;
  isDayTrade?: boolean;
}

interface ITradingModalStoreAction {
  onClose?: () => void;
  showModal?: (any) => void;
  resetModal: () => void;
  setSymbol?(symbol: ITradingModalStoreState['symbol']): void;
  setOrderType?: (any) => void;
  setModalState: (payload: ITradingModalStoreState) => void;
  setAutoBuy?: (isAutoBuy: boolean) => void;
  setPrice: (price: number | null) => void;
}

type ITradingModalStore = ITradingModalStoreState & ITradingModalStoreAction;

const initialState = {
  visible: false,
  symbol: null,
  price: null,
  orderType: null,
  showOrderbook: true,
  showTabs: false,
  showOrderType: false,
  orderedLot: null,
  orderid: null,
  orderedPrice: null,
  isAutoBuy: false,
  modalData: {},
  onClose: null,
  isDayTrade: false,
};

const tradingModalStore = create<ITradingModalStore>((set) => ({
  ...initialState,
  setPrice: (price) => {
    set({ price });
  },
  showModal: (payload) => {
    set({ visible: true, ...payload });
  },
  setAutoBuy: (isAutoBuy: boolean) => {
    set({ isAutoBuy });
  },
  resetModal: () => {
    set(initialState);
  },
  setSymbol: (symbol) => {
    set({ symbol });
  },
  setOrderType: (type) => {
    set({ orderType: type });
  },
  setModalState: (payload) => {
    set({ ...payload });
  },
}));

export default tradingModalStore;
